import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { LoaderActions } from "../../store/loader/actions";

export function useAppLoader() {
  const dispatch = useDispatch();
  return useCallback(
    async <T>(p: Promise<T>) => {
      try {
        dispatch(LoaderActions.setDefaultLoader());
        const temp = await p;
        dispatch(LoaderActions.clearLoader());
        return temp;
      } catch (e: any) {
        dispatch(LoaderActions.clearLoader());
        throw e;
      }
    },
    [dispatch]
  );
}
